module.exports = __webpack_public_path__ + "static/img/sycpbg.05e93a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sycpbg.png
// module id = ailo
// module chunks = 0